import { Button, IconButton, Popover } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ChevronDownIcon } from '../../../assets/icons';
import { DropdownMenuList } from './DropdownMenuList';
import { desktopHeaderStyles } from './styles';
import { useLocation } from 'react-router-dom';
import { AppIcon } from '../../app-icon/AppIcon';
import { MenuWithChildren } from '../../../types/menu';

interface MenuWithDropdownProps {
  menu: MenuWithChildren;
}
export const MenuWithDropdown: React.FC<MenuWithDropdownProps> = ({ menu }) => {
  const anchorElRef = useRef<HTMLAnchorElement | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const openDropdown = () => {
    setIsDropdownOpen(true);
  };
  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const location = useLocation();
  useEffect(() => {
    closeDropdown();
  }, [location]);

  return (
    <>
      <Button
        to={menu.link}
        ref={anchorElRef}
        sx={desktopHeaderStyles.menuLink}
        color="secondary"
        component={NavLink}
        end
      >
        {menu.display_name}
      </Button>
      {menu.children && menu.children.length > 0 && (
        <>
          <IconButton onClick={openDropdown} aria-label={`Show more ${menu.display_name} menus`}>
            <AppIcon sx={desktopHeaderStyles.menuDropdownIcon} Icon={ChevronDownIcon} />
          </IconButton>
          <Popover
            PaperProps={{
              sx: desktopHeaderStyles.menuDropdown,
            }}
            open={isDropdownOpen}
            anchorEl={anchorElRef.current}
            onClose={closeDropdown}
            anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          >
            <DropdownMenuList menu={menu} />
          </Popover>
        </>
      )}
    </>
  );
};
